<pillarandPriorities class="mb-5" />
<template>
  <div id="whynow">
    <div id="body"><div><h1 class="text-primary font-weight-bold mt-4">Why Now?</h1>
      <b-button variant= "primary" href="WHY Talking points flyer_10_17_22.pdf" target="_blank">Download Now</b-button>
      <pillarandPriorities class="mb-5" />
</div>
</div>
    <footer-bar />
    <!-- END -->
  </div>
</template>

<script>


import PillarandPriorities from "@/views/Home/PillarandPriorities.vue";
import FooterBar from "@/components/FooterBar.vue";


export default {
  name: "WhyNow",
  components: { FooterBar,PillarandPriorities },
  data: () => ({}),
};
</script>